import { useMemo, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import useApi from "../../hooks/useApi";

export default function ModalNovoEquipamento({ onClose, onCreated, tiposAtivo }) {
  const api = useApi();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    id_tipo_ativo: "",
    descricao: "",
    patrimonio: "",
    serial: "",
  });

  const canSubmit = useMemo(() => {
    return (
      Boolean(String(form.id_tipo_ativo || "").trim()) &&
      Boolean(form.descricao?.trim()) &&
      Boolean(form.patrimonio?.trim())
    );
  }, [form.descricao, form.id_tipo_ativo, form.patrimonio]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      if (name === "id_tipo_ativo") {
        return { ...prev, id_tipo_ativo: value };
      }
      return { ...prev, [name]: value.toUpperCase() };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSaving(true);

      await api.post("/Painel/API/InventarioTI/CreateAtivo/", {
        id_tipo_ativo: Number(form.id_tipo_ativo),
        descricao: form.descricao.trim().toUpperCase(),
        patrimonio: form.patrimonio.trim().toUpperCase(),
        num_serie: form.serial?.trim()?.toUpperCase() || null,
      });

      onClose?.();
      onCreated?.();
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Erro ao cadastrar equipamento.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Overlay state={true}>
      <Modal header close={onClose} size="md">
        <Formulario onSubmit={handleSubmit}>
          <FormComp
            title="TIPO"
            type="select"
            options={(tiposAtivo ?? []).map((t) => ({ value: String(t.id), label: t.descricao }))}
            obj
            valor={String(form.id_tipo_ativo || "")}
            name="id_tipo_ativo"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="EQUIPAMENTO"
            type="text"
            placeholder="EX: DELL LATITUDE 5420"
            valor={form.descricao}
            name="descricao"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="PATRIMÔNIO"
            type="text"
            placeholder="EX: TI-10293"
            valor={form.patrimonio}
            name="patrimonio"
            changeFunc={handleChange}
            required
          />
          <FormComp
            title="SERIAL"
            type="text"
            placeholder="EX: SN-XXXXX"
            valor={form.serial}
            name="serial"
            changeFunc={handleChange}
          />

          <FormComp
            type="submit"
            valor={saving ? "SALVANDO..." : "SALVAR"}
            disabled={saving || !canSubmit}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}
